import { render, staticRenderFns } from "./chemotherapy.vue?vue&type=template&id=44b80865&scoped=true"
import script from "./chemotherapy.vue?vue&type=script&lang=js"
export * from "./chemotherapy.vue?vue&type=script&lang=js"
import style0 from "./chemotherapy.vue?vue&type=style&index=0&id=44b80865&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b80865",
  null
  
)

export default component.exports